import { render, staticRenderFns } from "./GreetingCard.vue?vue&type=template&id=f81d5d2a&"
import script from "./GreetingCard.vue?vue&type=script&lang=js&"
export * from "./GreetingCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports